var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.379V126.621 c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38 C512,406.557,494.833,423.724,473.655,423.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M8.828,256.006h15.334l81.77-53.572v53.574h44.138v-53.574l81.77,53.574h15.334 c4.875,0,8.828-3.953,8.828-8.828v-7.002l-70.155-45.963H256v-44.138h-70.155L256,104.111v-7.002c0-4.875-3.953-8.828-8.828-8.828 h-15.334l-81.77,53.574V88.281H105.93v53.574l-79.093-51.82C17.606,92.936,9.886,99.24,5.13,107.471l65.025,42.603H0v44.138h70.155 L0,240.177v7.002C0,252.053,3.953,256.006,8.828,256.006z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,158.902 141.241,158.902 141.241,88.281 114.759,88.281 114.759,158.902 0,158.902  0,185.385 114.759,185.385 114.759,256.006 141.241,256.006 141.241,185.385 256,185.385  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M8.225,102.906l72.665,47.169h16.213l-82.5-53.554C12.235,98.392,10.093,100.535,8.225,102.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M166.283,150.074l88.374-57.366c-1.536-2.599-4.246-4.427-7.485-4.427h-1.909l-95.194,61.793 H166.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M89.474,194.212L1.269,251.468c1.519,2.663,4.273,4.537,7.559,4.537h1.665l95.196-61.793H89.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M255.86,247.872l-82.666-53.658H156.98l93.874,60.935 C253.666,253.843,255.595,251.107,255.86,247.872z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 325.36,
    y: 187.25,
    style: {
      fill: "#82AFFF"
    },
    width: 117.27,
    height: 90.63
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C86464"
    },
    d: "M325.362,277.874c0,30.913,34.649,55.972,58.638,55.972l0,0c21.323,0,58.638-25.06,58.638-55.972 L325.362,277.874L325.362,277.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M399.659,220.346c1.888,0.333,5.109,0.778,5.442,5.331c0.333,4.553-1.333,20.768-2.998,22.766 c0,0,5.442,12.328,5.664,19.657c0.222,7.33-0.777,29.263-0.111,32.761c0.667,3.498,3.165,10.661,3.165,10.661 s-7.663-4.498-10.661-1.666c-2.998,2.831-13.993,6.664-18.325,2.166c0,0,5.164-14.659,5.164-31.318s0-57.805,0-57.805 s2.166-1.721,4.997-1.777C394.828,221.068,399.659,220.346,399.659,220.346z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5E1"
    },
    d: "M400.769,308.415c0.333,2.11,1.221,3.665,0.777,4.442c-0.445,0.778-3.331,7.885-1.666,7.885 s4.553-0.888,5.331-2.443c0.777-1.555,1.11-3.887,1.555-4.553s-0.778-3.998-1.777-4.553 C403.99,308.637,400.769,308.415,400.769,308.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5E1"
    },
    d: "M381.557,225.011l-6.108,0.778c0,0,0.777-3.998,0.888-6.775c0.111-2.776,0.333-7.885,0.333-7.885 s4.331-2.665,4.442-3.11c0.055-0.222,0.569-1.61,0.167-2.332s-1.721-0.778-1.721-0.778s-5.109,2.665-5.109,3.11s0,3.11-0.555,4.109 c-0.555,1-3.665,9.329-3.887,11.55c-0.222,2.221-0.555,6.886,0.333,7.108s10.106,1.222,11.106,0.777 C382.445,231.119,381.557,225.011,381.557,225.011z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#464655"
    },
    points: "409.229,203.078 386.998,203.078 386.998,192.583 379.336,192.583 379.336,203.078  357.105,203.078 357.105,210.74 379.336,210.74 379.336,311.524 386.998,311.524 386.998,210.74 409.229,210.74 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#963C3C"
    },
    d: "M396.105,216.682c0,0,7.441,2.143,8.44-0.333c1.166-2.888-2.721-3.276-3.443-6.33 c-0.081-0.342-0.777-4.442-3.776-5.219c-2.998-0.778-5.775,0-5.886,1.999S396.105,216.682,396.105,216.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5E1"
    },
    d: "M392.107,226.121c-0.22,0.036-0.555-2.221-0.111-4.998c0.445-2.776,0-3.665,0-3.665 s-3.109,0.333-3.109-0.888s0.666-6.886,2.554-9.773c0,0,1.333,1.666,3.776,1.666c0,0-0.111,1.999,1.222,3.331 c0,0-1.666,1.443-0.888,2.443s2.221,2.221,2.221,2.221s0.111,2.333,1.888,3.887C399.659,220.346,397.438,225.233,392.107,226.121z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 361.68,
    y: 274.32,
    style: {
      fill: "#464655"
    },
    width: 0.666,
    height: 13.215
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.36,
    y: 271.76,
    style: {
      fill: "#464655"
    },
    width: 0.666,
    height: 18.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.04,
    y: 269.43,
    style: {
      fill: "#464655"
    },
    width: 0.666,
    height: 23.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.72,
    y: 266.09,
    style: {
      fill: "#464655"
    },
    width: 0.666,
    height: 29.688
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.4,
    y: 261.72,
    style: {
      fill: "#464655"
    },
    width: 0.666,
    height: 38.424
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.08,
    y: 261.72,
    style: {
      fill: "#464655"
    },
    width: 0.666,
    height: 40.22
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M387.109,282.76c-2.945-15.315-11.106-24.211-13.993-24.654c-2.888-0.444-4.997,1.888-5.219,3.554 s-1.777,6.664-4.998,8.995c-3.221,2.333-9.218,3.665-10.55,7.996c-1.333,4.331,2.221,6.219,4.331,5.774 c0.158-0.033,0.313-0.095,0.471-0.147l22.703,27.927c0.824,1.014,2.43,0.849,3.005-0.327 C385.192,307.109,389.621,295.818,387.109,282.76z M359.057,283.07c0.89-0.956,1.266-2.273,0.289-3.641 c-1.666-2.333-3.554,1-3.554,1s-0.555-2.888,3.776-4.331s9.218-3.886,11.439-9.107c2.221-5.219,2.11-4.221,2.11-4.221 s8.885,4.998,10.106,20.657c1.222,15.659-3.109,21.99-3.109,21.99L359.057,283.07z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5E1"
    },
    d: "M379.336,249.255c-1.02,0.652-1.939,1.214-2.582,1.549c-2.082,1.082-4.582,2.166-4.831,3.165 c-0.249,1-1.666,1.833-1.582,2.998c0.084,1.166,0,4.664,0,4.664c1.249-0.249,3.748-0.666,4.582-2.166 c0.833-1.5,1.582-4.415,4.248-5.664c0.047-0.022,0.117-0.045,0.167-0.067v-4.479L379.336,249.255L379.336,249.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5E1"
    },
    d: "M401.408,227.981c-1.249,0.583-4.997,5.081-5.58,7.164c-0.583,2.082-2.415,6.997-2.415,6.997 s-3.785,0.494-6.413,1.965v7.274c1.457-0.422,2.745-0.838,3.498-1.242c2.166-1.166,5.247-3.331,6.83-3.748 c1.582-0.416,2.915-3.082,3.498-4.664c0.583-1.582,2.415-6.247,2.665-9.412C403.741,229.148,402.657,227.399,401.408,227.981z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M384,335.736l-0.291-0.046c-59.529-9.399-60.213-60.958-60.213-63.146v-87.158h121.009v87.158 c0,2.189-0.684,53.747-60.213,63.146L384,335.736z M327.229,189.118v83.425c0,2.057,0.644,50.387,56.771,59.414 c56.128-9.027,56.771-57.357,56.771-59.414v-83.425H327.229z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMs);
export default __webpack_public_path__ + "static/media/ms.2af363e56513e892d8799df3c1b11eed.svg";
export { ForwardRef as ReactComponent };